import { omit } from "lodash";
import styled from "styled-components";
import { colours } from "../../../styles/colours";
import { Icon, IconType } from "../../icons";
import {
  barSize,
  CustomItemProps,
  iconBackgroundSize,
  IconContainer,
  iconLeftPadding,
  iconSize,
  Item,
  Variant,
} from "./base";

type PrimaryItemProps = CustomItemProps & {
  variant?: Extract<Variant, "main" | "sub">;
};

const StyledItem = styled(Item)`
  color: ${colours.white};
  position: relative;
`;

/** Main Variant */
const MainIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.primaryBlue} />,
  ...omit(props, "icon"),
}))`
  background: ${colours.white};
`;

/** Sub Variant */
const SubIcon = styled(IconContainer).attrs<
  { icon: IconType },
  React.ComponentProps<typeof IconContainer>
>((props) => ({
  center: true,
  children: <Icon type={props.icon} colour1={colours.white} />,
  ...omit(props, "icon"),
}))``;

const Container = styled.div`
  position: relative;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${colours.white};
  z-index: 0;
`;

const Foreground = styled(Background)`
  top: 10%;
  width: calc(100% - 2em);
  bottom: 10%;
  background: ${colours.primaryBlue};
  border-bottom-right-radius: 25px;
  border-top-right-radius: 25px;
`;

const padding = (iconBackgroundSize * iconSize * (barSize - 1)) / 2;

const CompactForeground = styled(Foreground)`
  left: ${iconLeftPadding}em;
  width: ${iconBackgroundSize * iconSize}em;
  border-radius: 10px;
  bottom: ${padding}em;
  top: ${padding}em;
`;

export const PrimaryItem: React.FunctionComponent<PrimaryItemProps> = (
  props
) => (
  <Container>
    <Background />
    {props.compact ? <CompactForeground /> : <Foreground />}
    {props.variant === "sub" ? (
      <StyledItem
        {...props}
        icon={props.icon && <SubIcon icon={props.icon} />}
      />
    ) : (
      <StyledItem
        {...props}
        icon={props.icon && <MainIcon icon={props.icon} />}
      />
    )}
  </Container>
);
